const replaceRegex = /\{\{[^{{}}]*\}\}/g;

type ReplaceTex = (word: string, termValues: Record<string, string>) => string;
export const replaceText: ReplaceTex = (word, termValues) =>
  Object.keys(termValues).reduce((acum, key) => acum.replace(replaceRegex, termValues[key]), word);
